/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { PlatformPressable } from '@react-navigation/elements';
import {
  useNavigation,
  useNavigationState,
  type NavigationProp,
  type ParamListBase,
} from '@react-navigation/native';
import type { BottomTabBarButtonProps } from '@react-navigation/bottom-tabs';
import {
  DEFAULT_MAIN_TAB_ROUTE,
  useLastMainTabOptional,
} from './LastMainTabContext';
import { MOBILE_MORE_TAB_ROUTE } from './navigationManifest';

type Props = BottomTabBarButtonProps;

/** Segundo tap en «Más» vuelve al último tab operativo (patrón familiar en apps con hub). */
export function MoreTabBarButton(props: Props) {
  const navigation = useNavigation<NavigationProp<ParamListBase>>();
  const lastMainTab = useLastMainTabOptional();
  const isFocused = useNavigationState(
    (state) => state?.routes[state.index]?.name === MOBILE_MORE_TAB_ROUTE
  );

  return (
    <PlatformPressable
      {...props}
      onPress={(event) => {
        if (isFocused) {
          navigation.navigate(lastMainTab?.lastTabRoute ?? DEFAULT_MAIN_TAB_ROUTE);
          return;
        }
        props.onPress?.(event);
      }}
    />
  );
}
